<ion-content class="ion-padding">
    <app-autosave
        #autosave
        [hidden]="status !== FinalEvaluationStatus.NotSent && !(isBusinessPartner && calibration)"
        [isSaving]="autoSaving"
        [pendingChanges]="hasPendingChanges"
        [setDisabled]="meetingClosed"
    ></app-autosave>

    <app-preview-ninebox
        *ngIf="showNineboxPreview && nineboxConfig && nineboxXOrder && nineboxYOrder"
        [nineboxConfig]="nineboxConfig"
        [xValue]="formGroup.controls['field' + nineboxXOrder].value"
        [yValue]="formGroup.controls['field' + nineboxYOrder].value"
    ></app-preview-ninebox>

    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap"> {{ getText(processConfig?.globalizationConfig, 'title') | uppercase }} </ion-label>
        </ion-item>

        <app-step-description
            [description]="getText( processConfig?.globalizationConfig, 'instructions' )"
            [employee]="{
                                                imageUrl: getImageUrl(user?.imageUrl),
                                                username: user?.name,
                                                rank: user?.rank,
                                                area: user?.area
                                            }"
        ></app-step-description>

        <ion-item lines="none" mode="ios" class="para-content" *ngIf="formGroup">
            <ion-grid>
                <ion-row size="auto">
                    <ion-col size="4"></ion-col>
                    <ion-col class="btns" size="8">
                        <ion-button *ngIf="canSeePreviousEvaluations" color="primary" (click)="viewPreviousEvaluations()">
                            {{ 'managerEvaluation.seePreviousEvaluations' | translate | uppercase }}
                        </ion-button>
                        <ion-button *ngIf="aiReviewEnabled && (hasAiReviewRole || hasAiReviewAttribute)" color="primary" (click)="viewGeneralSummary()">
                            <div class="icon-custom-star-shining"></div>
                            {{ 'aiSummary.detailed.buttonTitle' | translate | uppercase }}
                        </ion-button>
                        <ion-button color="primary" *ngIf="!hideSeeEvaluations" (click)="view360Review()">
                            {{ 'managerEvaluation.seeEvaluations' | translate | uppercase }}
                        </ion-button>
                        <ion-button color="primary" (click)="goToNotepad()"> {{ 'selfEvaluation.seeNotes' | translate | uppercase }} </ion-button>
                        <ng-container *ngIf="hasTwoPlusTwoCoaching && !hideTwoPlusTwoButton">
                            <ion-button color="secondary" (click)="goToCoaching()"> {{ 'selfEvaluation.seeCoaching' | translate | uppercase }} </ion-button>
                        </ng-container>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-item>

        <ion-item lines="none" mode="ios" class="para-content form">
            <form [formGroup]="formGroup" *ngIf="formGroup">
                <div *ngFor="let group of processConfig.questionsGroups | questionGroupAttributes: user?.attributes; let groupIndex = index;">
                    <ng-container *ngIf="(group.hasCalculateQuestions && !questionsType[QuestionType.Calculate].hidden) ||  !group.hasCalculateQuestions">
                        <h4>
                            {{ !hideQuestionNumber ? (groupIndex + 1) + ' - ' + getText(group.globalizationConfig, 'title') : getText(group.globalizationConfig, 'title') }}
                            <span
                                class="tooltip"
                                *ngIf="getText(group.globalizationConfig, 'instructions')"
                                [matTooltip]="getText(group.globalizationConfig, 'instructions')"
                                matTooltipClass="tooltip-content"
                                >?
                            </span>
                        </h4>
                    </ng-container>

                    <ng-container *ngFor="let question of group.questions">
                        <app-question-types [question]="question" [evaluation]="user?.selfEvaluation" [formGroup]="formGroup" [goalsIndexes]="goalsIndexes"></app-question-types>
                    </ng-container>
                </div>
            </form>
        </ion-item>

        <ng-container *ngIf="status === FinalEvaluationStatus.NotSent || (isBusinessPartner && calibration)">
            <div class="bottom-buttons" text-right>
                <ion-button mode="ios" color="primary" class="save" (click)="save(formGroup)" [disabled]="isSaving"> {{ 'generic.save' | translate }} </ion-button>
                <ion-button
                    mode="ios"
                    color="secondary"
                    class="save"
                    *ngIf="status === FinalEvaluationStatus.NotSent && !calibration"
                    (click)="send(formGroup)"
                    [disabled]="isSaving"
                >
                    {{ 'generic.sendEvaluation' | translate }}
                </ion-button>
            </div>
        </ng-container>
    </div>
</ion-content>
